(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name seniorityList.controller:SeniorityListCtrl
   *
   * @description
   *
   */
  angular
    .module('seniorityList')
    .controller('SeniorityListCtrl', SeniorityListCtrl);

  function SeniorityListCtrl(CommonMasterData, $sce, CommonLogicService) {
    var vm = this;
    vm.ctrlName = 'SeniorityListCtrl';
    vm.model = {
      searchPanelToggle: true,
      searchCriteria: {
        rewType: null
      },
      masterList: {
        crewTypeList: []
      },
      initialSearchDone: false,
      reportDataURL: null,
      reportServerBaseUrl: null
    };

    // toggle search
    vm.clickOnSearch = function () {
      vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
      vm.model.initialSearchDone = false;
    };
    // submit search
    vm.submitSearch = function (params) {
      searchSeniorityList(params);
    };
    // search seniority list
    function searchSeniorityList(param) {
      vm.model.initialSearchDone = true;
      vm.model.searchCriteria = param;
      vm.model.searchPanelToggle = false;
      var url = CommonLogicService.getReportUrl(
        "seniority_list.rptdesign",
        getSearchParamMap(param));
      vm.model.reportDataURL = $sce.trustAsResourceUrl(url);

    }
    // set search param map
    function getSearchParamMap(param) {
      var searchParamMap = {};
      searchParamMap["crewType"] = param.crewType.crewTypeCode;
      return searchParamMap;
    }

    (function () {
      // crew type codes
      CommonMasterData.getCrewTypeList(function (crewTypeList) {
        var masterCode="FC";
        var newCrewTypeList=[];
        crewTypeList.forEach(function (crewTypeList) {
          if(masterCode.localeCompare(crewTypeList.crewTypeMasterCode)===0) {
            newCrewTypeList.push(crewTypeList);
          }
        })
        vm.model.masterList.crewTypeList = newCrewTypeList;
      }, function () {
        console.log('Crew Type list retrieval error');
      });

    })();


  }
}());
